
import React, { useEffect, useState, useRef, createRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import Carregando from '../../components/Carregando/Carregando';

import { 
  buscarFichasPendentesDePagamento, criarCheckoutPagBank, criarPagamentoPagBankGerandoToken,
  getChavePublica
} from '../../services/api';

import { atualizarDadosClienteLogado, getFinalCartaoUsuarioLogado } from '../../services/clienteService';

// cookies
import Cookies from 'js-cookie';

// css
import '../../styles/global.css';
import './MinhasFichas.css';

/* eslint-disable no-restricted-globals */

const MinhasFichas = () => {

  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(false); // Estado de carregamento

  const [fichas, setFichas] = useState([]);
  const [carregando, setCarregando] = useState(true);

  // buscar as fichas periodicamente
  const [intervalId, setIntervalId] = useState(null);

  // vamos pegar o dadosCheckin dos cookies
  // const dadosCheckin = JSON.parse(sessionStorage.getItem('dadosCheckin')) || {};
  const dadosCheckin = JSON.parse(Cookies.get('dadosCheckin')) || {};
  const cpfClienteCheckin = dadosCheckin.numeroCpf;
  const nomeCliente = dadosCheckin.nome;
  const nomeEstabelecimento = dadosCheckin.estabelecimento.nome;

  // dados do usuário, inclusive se for cliente logado
  const userData = JSON.parse(sessionStorage.getItem('userData')) || {};
  
  // vamos verificar o perfil do usuário
  const perfilUsuario = userData && userData.dadosPerfil ? userData.dadosPerfil.nome : null;

  var valorTotalConta = 0;

  useEffect(() => {
      console.log('----- ENTROU NO MinhasFichas -----');

      console.log('cpf do cliente: ');
      console.log(cpfClienteCheckin);

      // chamar o método que atualiza os dados do cliente logado
      atualizarDadosClienteLogado(userData);

      // vamos chamar o método que carrega os dados
      loadData();

  }, []);


  useEffect(() => {
      const id = setInterval(fetchFichas, 10000); // 30 segundos
      setIntervalId(id);
      return () => clearInterval(id);
  }, []);



  // método que pega a localização e busca os estabelecimentos
  const loadData = async () => {
      console.log(' *** Entrou no loadData ***');
      console.log('Dados do checkin: ');
      console.log(dadosCheckin);
      try {
          await fetchFichas(); 
      } catch (err) {
          console.log("Erro ao buscar as fichas:", err);
      }
  };



  // fazer o checkout no pagbank - cliente paga diretamente no ambiente do pagbank
  const handleCriarCheckoutPagBank = async () => {

    setCarregando(true);

    console.log('--- ============== ---');
    console.log('Entrou em criarCheckoutPagBank em MinhasFichas.js');

    try {
      const dados = await criarCheckoutPagBank(fichas, cpfClienteCheckin);

      console.log('!!!!!! Dados recebidos do checkout: ');
      console.log(dados);

      console.log('Links:');
      console.log(dados.response.links);

      const payLink = dados.response.links.find(item => item.rel === 'PAY').href;


      // redirecionar cliente para pagamento pagbank
      window.location.href = payLink;

      setCarregando(false);


    } catch (error) {

      setCarregando(false);

      if (error.response && error.response.status === 422) {
        alert('CPF inválido!!!');
      }
      console.error('Erro ao fazer o checkout no PagBank:', error);
    }
  };


  /**
   * Método que criptografa o cartão
   */
  // const handleEncryptCard = async (chavePublica) => {
  //   console.log('Entrou em handleEncryptCard...');
  //   if (!window.PagSeguro) {
  //     alert('SDK do PagSeguro ainda não foi carregada!');
  //     return;
  //   }
  
  //   const card = window.PagSeguro.encryptCard({
  //     // publicKey: chavePublica,
  //     publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB',
  //     holder: userData.dadosCliente.nome_como_esta_no_cartao,
  //     number: userData.dadosCliente.numero_cartao,
  //     expMonth: userData.dadosCliente.mes_validade_cartao,
  //     expYear: userData.dadosCliente.ano_validade_cartao,
  //     securityCode: userData.dadosCliente.codigo_cartao,
  //   });
  
  //   if (card.hasErrors) {
  //     console.error('Erros na criptografia do cartão:', card.errors);
  //     alert('Erro nos dados do cartão.');
  //     return;
  //   }

  //   const cartaoCriptografado = card.encryptedCard;
  
  //   console.log('Cartão criptografado (em handleEncryptCard...):');
  //   console.log(cartaoCriptografado);
  //   console.log('Tamanho do cartão criptografado:');
  //   console.log(cartaoCriptografado ? cartaoCriptografado.length : null);


  //   // encryptedCard = encodeURIComponent(card.encryptedCard);

  //   return card.encryptedCard;

  // };
  

  // gerar o pagamento, gerando o token para utilização futura
  const handleCriarPagamentoPagBankGerandoToken = async (e) => {

    setCarregando(true);

    console.log('--- ============== ---');
    console.log('Entrou em handleCriarPagamentoGerandoToken em MinhasFichas.js');
    console.log('userData: ');
    console.log(userData);

    e.preventDefault();
    /**
     * Precisaremos buscar a chave pública para criptografarmos o cartão
     */
    let chavePublica = null;
    const cartaoCriptografado = userData.dadosCliente.cartao_criptografado_pagbank;

    /**
     * Agora com a chave pública em mãos, vamos criptografar o cartão
     */
    // const cartaoCriptografado = await handleEncryptCard(chavePublica);
    userData.dadosCliente.cartao_criptografado_pagbank = cartaoCriptografado;
    sessionStorage.setItem('userData.dadosCliente.cartao_criptografado_pagbank', JSON.stringify(cartaoCriptografado));

    try {
      const dados = await criarPagamentoPagBankGerandoToken(fichas, userData);

      console.log('!!!!!! Dados recebidos do checkout após criar pagamento gerando token: ');
      console.log(dados);

      alert('Pagamento efetuado com sucesso!');

      setCarregando(false);

      navigate('/');

    } catch (error) {
      setCarregando(false);
      if (error.response && error.response.status === 422) {
        alert('CPF inválido!!!');
      }
      console.error('Erro ao fazer o checkout no PagBank:', error);
    }
  };




  // buscar todos os produtos do estabelecimento, para checkar os que já tem
  const fetchFichas = async () => {
    console.log('Entrou em fetchFichas em MinhasFichas');

    try {
      const dados = await buscarFichasPendentesDePagamento(dadosCheckin);

      console.log('*** fichas ***', dados.fichas);

      if (dados?.fichas) {
        console.log('-> Fichas: ', dados.fichas);
        setFichas(dados.fichas);
        setCarregando(false);
      }
    } catch (error) {
      console.error('Erro ao buscar fichas:', error);
    }
  };

  if (carregando) {
    return <Carregando />;
  }

  return (
    <div autoFocus className="fichas-container">
      <TituloComponent />

      <h1 className="sub-titulo">Fichas pendentes de pagamento</h1>
      
      <div className="box-dados">
        {
          nomeCliente
          ?
          <p className="texto-welcome">{nomeCliente},</p>
          :
          <></>
        }
        
        <p className="texto-welcome">Bem-vindo ao {nomeEstabelecimento}!</p>

        {/* <div className="divisor">&nbsp;</div> */}

        {/* Calcular o valor total a ser pago */}
        {fichas.map((ficha, index) => {
            const valor = ficha.preco * ficha.quantidade;
            const statusPedido = ficha.status_pedido;
            if(statusPedido == 'FICHA SOLICITADA PELO CLIENTE'){
              valorTotalConta = (valorTotalConta + valor);
            }
            // return (
            //   <div key={index}>
            //       <p className="texto-welcome">
            //       {ficha.quantidade} {ficha.nome_produto} R$ {valor}
            //       </p>
            //       <div className="divisor">&nbsp;</div>
            //   </div>            
            // );
        })}
      </div>

      {/* Container de quadros */}
      {fichas.map((ficha, index) => (
          console.log('ficha = ', ficha),

          <div
            key={ficha.produto_pedido_id}  
            data-index={index} // O índice para o swipeHandler identificar
            data-id={ficha.produto_pedido_id} // O ID da ficha
            className="box-dados-ficha"
          >

          <p className="texto-ficha-numero">{ficha.produto_pedido_id}</p>
          <p className="texto-ficha-nome-produto">{ficha.nome_produto}</p>
          <p className="texto-ficha-preco">R$ {ficha.preco}</p>
          {/* <p className="texto-ficha-nome-produto">{ficha.status_pedido}</p> */}
          

          {/* <p className="texto-welcome">Status: {ficha.status_pedido}</p> */}
        </div>

      ))}
        {
          valorTotalConta > 0 ? (

              // se o usuário estiver logado, mostraremos o cartão que será utilizado
              userData.statusUsuario == 'logado' && perfilUsuario == 'BAR CLIENTE'
              ?
                <div className="box-dados">           
                  <div className="form-group">

                    <p className="texto-welcome">Total: R$ {valorTotalConta}</p>


                    <label htmlFor="numeroMesa">Cartão salvo: final {getFinalCartaoUsuarioLogado(userData)} </label>

                    <button onClick={handleCriarPagamentoPagBankGerandoToken}>
                      Pagar com cartão salvo
                    </button>

                    <label htmlFor="numeroMesa">Informar os dados no ato do pagamento</label>
                    <button onClick={handleCriarCheckoutPagBank}>
                      Pagar no PagBank
                    </button>                    

                  </div>


                </div>
              :
                <div className="form-group">

                  <label htmlFor="numeroMesa">Você não possui cartão salvo</label>

                  <hr></hr>


                  <label htmlFor="numeroMesa">Informar os dados no ato do pagamento</label>
                  <button onClick={handleCriarCheckoutPagBank}>
                    Pagar no PagBank
                  </button>
                </div>





          ) : (
            <p className="texto-ficha-usar">Você não fez nenhum pedido</p>
          )
        }

    </div>
  );
};

export default MinhasFichas;
